const testimonials = [
  {
    name: 'Sarah Thompson',
    role: 'Homeowner, Houston TX',
    initials: 'ST',
    color: 'bg-rose-100 text-rose-600',
    stars: 5,
    text: 'After a burst pipe flooded our entire ground floor, MRS arrived within 45 minutes. Their team was professional, thorough, and incredibly reassuring during a very stressful time. Our home looks better than before!',
  },
  {
    name: 'Marcus Rivera',
    role: 'Property Manager',
    initials: 'MR',
    color: 'bg-teal-100 text-teal-600',
    stars: 5,
    text: 'I manage 12 rental properties and MRS is my go-to for any water or fire damage. Their documentation for insurance claims is impeccable and they always deliver on time. Highly recommend.',
  },
  {
    name: 'Linda Chen',
    role: 'Business Owner',
    initials: 'LC',
    color: 'bg-amber-100 text-amber-600',
    stars: 5,
    text: 'A kitchen fire caused significant smoke damage throughout our restaurant. MRS had us back open in just 8 days. Their odor elimination technology is remarkable — no trace of smoke at all.',
  },
  {
    name: 'David Okafor',
    role: 'Homeowner, Dallas TX',
    initials: 'DO',
    color: 'bg-indigo-100 text-indigo-600',
    stars: 5,
    text: 'The mold remediation team was exceptional. They found hidden moisture behind walls that two other companies missed. Thorough, honest, and fairly priced. Will use again without hesitation.',
  },
  {
    name: 'Patricia Walsh',
    role: 'Insurance Adjuster',
    initials: 'PW',
    color: 'bg-green-100 text-green-600',
    stars: 5,
    text: 'As an insurance adjuster, I work with many restoration companies. MRS consistently provides the most detailed and accurate documentation, making claims processing smooth and efficient.',
  },
  {
    name: 'Robert Kim',
    role: 'Commercial Property Owner',
    initials: 'RK',
    color: 'bg-purple-100 text-purple-600',
    stars: 5,
    text: 'Flooding in our warehouse could have been catastrophic. MRS contained the damage, dried everything out, and restored our operations in record time. Their 24/7 availability is a lifesaver.',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-[#F0F4F8]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <span className="inline-flex items-center gap-2 bg-[#DC2626] text-white text-xs font-semibold px-4 py-1.5 rounded-full uppercase tracking-widest">
              <i className="ri-star-fill"></i>
              Client Reviews
            </span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-[#1E3A5F] mt-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Trusted by Property Owners<br />Across the Region
            </h2>
          </div>
          <div className="flex items-center gap-6">
            <div className="text-center">
              <p className="text-4xl font-extrabold text-[#1E3A5F]">4.9</p>
              <div className="flex items-center gap-0.5 justify-center mt-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-1">Average Rating</p>
            </div>
            <div className="w-px h-12 bg-gray-300"></div>
            <div className="text-center">
              <p className="text-4xl font-extrabold text-[#1E3A5F]">1,200+</p>
              <p className="text-gray-500 text-xs mt-1">Verified Reviews</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-white rounded-2xl p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-11 h-11 flex items-center justify-center rounded-full font-bold text-sm ${t.color}`}>
                  {t.initials}
                </div>
                <div>
                  <p className="font-bold text-[#1E3A5F] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.role}</p>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-3">
                {[...Array(t.stars)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed">&ldquo;{t.text}&rdquo;</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
